var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17114 18.0428L3.47255 14.7013C3.23079 14.5632 3.04516 14.3732 2.91564 14.1315C2.78613 13.8897 2.72137 13.6307 2.72137 13.3544V6.69741C2.72137 6.42111 2.78613 6.16209 2.91564 5.92033C3.04516 5.67857 3.23079 5.48862 3.47255 5.35047L9.19704 1.95722C9.4388 1.81907 9.70646 1.75 10 1.75C10.2936 1.75 10.5612 1.81907 10.803 1.95722L16.5275 5.35047C16.7693 5.48862 16.9549 5.67857 17.0844 5.92033C17.2139 6.16209 17.2787 6.42111 17.2787 6.69741V13.3544C17.2787 13.6307 17.2096 13.8897 17.0715 14.1315C16.9333 14.3732 16.7434 14.5632 16.5016 14.7013L10.7253 18.0428C10.4835 18.1809 10.2245 18.25 9.94822 18.25C9.67192 18.25 9.4129 18.1809 9.17114 18.0428ZM9.22294 16.2555V10.4533L4.30144 7.6299V13.3026L9.22294 16.2555ZM10.7771 16.2555L15.7245 13.3026V7.6299L10.7771 10.4533V16.2555ZM10 9.05455L14.9215 6.20526L10 3.38187L5.07852 6.20526L10 9.05455Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume);
export default __webpack_public_path__ + "static/media/icon-volume.1babc7dd96ec6fc38e6c89b4e36365d9.svg";
export { ForwardRef as ReactComponent };